import { useTranslations } from "next-intl";
import Image from "next/image";
import { RegularModal } from "../modals/modals";
import { useId } from "react";

export const PerksModal = ({ isOpen, onRequestClose, customerPerks }: any) => {
  const t = useTranslations("PerksModal");
  const availablePerks = customerPerks?.filter(
    (perk: { available: boolean }) => perk.available
  );
  const unavailablePerks = customerPerks?.filter(
    (perk: { available: boolean }) => !perk.available
  );
  const titleId = useId();
  const subtitleId = useId();

  return (
    <RegularModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="bg-opacity-75"
      contentClassName="bg-white sm:rounded-lg shadow-lg w-[100%] h-[100%] sm:h-auto sm:w-full max-w-md md:max-w-lg lg:max-w-xl mx-auto overflow-hidden"
      aria={{ labelledby: titleId, describedby: subtitleId }}
    >
      <h2
        id={titleId}
        aria-describedby={subtitleId}
        className="pt-10 px-6 text-4xl text-[32px] font-medium text-[#373737]"
      >
        {t("perks")}
      </h2>
      <div id={subtitleId} className="py-4 px-6">
        {availablePerks && availablePerks.length > 0 && (
          <div>
            <p className="mb-4 text-[15px] text-md text-[#373737]">
              {t("availPerks")}
            </p>
            <p className="mb-4 text-[15px] text-md text-[#373737]">
              {t("redeemPerks")}
            </p>
          </div>
        )}
        {availablePerks?.map(
          (perk: {
            uuid: string;
            title: string;
            iconUrl: string;
            backgroundUrl: string;
          }) => (
            <div
              className="p-4 rounded-lg gap-2 flex items-center"
              key={perk.uuid}
            >
              <div className="relative w-[48px] h-[48px]">
                <Image
                  aria-hidden={true}
                  src={perk.backgroundUrl}
                  layout="fill"
                  objectFit="contain"
                  alt={perk.title}
                />
                <Image
                  aria-hidden={true}
                  src={perk.iconUrl}
                  layout="fill"
                  objectFit="contain"
                  alt={perk.title}
                />
              </div>
              <div className="text-black">{perk.title}</div>
            </div>
          )
        )}

        {unavailablePerks?.length > 0 && (
          <>
            <p className="mt-4 mb-4 text-[15px] text-md">{t("inProgress")}</p>
            {unavailablePerks?.map(
              (perk: {
                uuid: string;
                title: string;
                iconUrl: string;
                backgroundUrl: string;
                earned: number;
                required: number;
              }) => {
                const progressPercentage = Math.min(
                  (perk.earned / perk.required) * 100,
                  100
                );

                return (
                  <div
                    className="p-4 rounded-lg flex items-center gap-2 mb-4 shadow-[0_2px_6px_0px_rgba(37,51,56,0.15)]"
                    key={perk.uuid}
                  >
                    <div className="relative w-[48px] h-[48px]">
                      <Image
                        aria-hidden={true}
                        src={perk.backgroundUrl}
                        layout="fill"
                        objectFit="contain"
                        alt={perk.title}
                      />
                      <Image
                        aria-hidden={true}
                        src={perk.iconUrl}
                        layout="fill"
                        objectFit="contain"
                        alt={perk.title}
                      />
                    </div>
                    <div className="text-black flex-1">
                      <div>{perk.title}</div>
                      <div className="w-full h-1 bg-gray-200 rounded-full mt-2">
                        <div
                          className="h-1 bg-yellow-500 rounded-full"
                          style={{ width: `${progressPercentage}%` }}
                        ></div>
                      </div>
                    </div>
                  </div>
                );
              }
            )}
          </>
        )}
      </div>
    </RegularModal>
  );
};
